// extracted by mini-css-extract-plugin
module.exports = {"header":"a630f0e637--header--SEbzw","jk-list":"a630f0e637--jk-list--chtl7","pagination":"a630f0e637--pagination--jCwP4","load-more":"a630f0e637--load-more--EAaHx"};